<template>
  <div class="contentbox" v-if="webConfig">
    <div class="header">
      <div class="headerbox">
        <img :src="`${IP_TEST}/uploads/${webConfig.logopic}`" alt="" @click="$router.push('/')">
        <div class="back">
            <a class="light" href="/inquery">继续查询</a>
            <a href="/">返回页面</a>
        </div>
        
      </div>
      
    </div>
    <div class="show" v-if="showInfo">
      <div class="toplogo">
        <h1>查询结果</h1>
      </div>
      <!-- <div class="tip">根据中国专家智库网人才入库审核标准，经评定！信息符合职业技术人才入库审核标准，同意您加入专家智库。</div> -->
        <table  class="personInfo" style="margin-top: 28px;">
          <!-- <tr class="theader">
            <th colspan="5">
              人员基本信息
            </th>
          </tr> -->
          <tr>
            <td v-if="!(showInfo.certtypename=='专业能力类'||showInfo.certtypename=='职业能力等级类'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书')" rowspan="4" style="padding:15px;width:200px">
              <img :src="`/uploads/xlsfile/usepic/${showInfo.picsrc}`" alt="">
            </td>
            <td style="width: 111px;">姓名</td>
            <td>{{ showInfo.name }}</td>
            <td style="width: 111px;">性别</td>
            <td>{{ showInfo.sex }}</td>
          </tr>
          <tr>
            <td style="width: 111px;">证件类型</td>
            <td>{{ showInfo.cardtype }}</td>
            <td style="width: 111px;">身份证号</td>
            <td>{{ showInfo.cardid }}</td>
          </tr>
          <tr>
            <td style="width: 111px;">出生日期</td>
            <td>{{ showInfo.birthday }}</td>
            <td style="width: 111px;">学历</td>
            <td>{{ showInfo.education }}</td>
          </tr>
          <tr>
            <td style="width: 111px;">工作单位</td>
            <td colspan="3">{{ showInfo.danwei }}</td>
          </tr>
        </table>
        <div class="theader">证书基本信息</div>
        <table  class="personInfo" v-if="showInfo.certtypename=='专业能力类'||showInfo.certtypename=='职业能力等级类'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书'">
          <!-- <tr class="theader">
            <th colspan="4">
              
            </th>
          </tr> -->
          <tr>
            <td>证书编号</td>
            <td colspan="3">{{ showInfo.code }}</td>
          </tr>
          <tr>
            <td>申报专业</td>
            <td colspan="3">{{ showInfo.certname }}</td>
          </tr>
          <tr>
            <td>证书类别</td>
            <td colspan="3">{{ showInfo.certtypename }}</td>
          </tr>
          <tr>
            <td>考试成绩</td>
            <td>{{ showInfo.certscore }}</td>
            <td>申报级别</td>
            <td>{{ showInfo.certlevel }}</td>
          </tr>
          <tr>
            <td>发证日期</td>
            <td colspan="3">{{ showInfo.certdate }}</td>
            <!-- <td>有效日期</td>
            <td>{{ formatExcelData(showInfo.valieddate) }}</td> -->
          </tr>
          <tr>
            <td>证书颁发机构</td>
            <td colspan="3">{{ showInfo.regauth }}</td>
          </tr>
          <tr>
            <td>发证机构网址</td>
            <td colspan="3">{{ showInfo.regurl }}</td>
          </tr>
        </table>
        <table  class="personInfo" v-else>
          <!-- <tr class="theader">
            <th colspan="4">
              证书基本信息
            </th>
          </tr> -->
          <tr>
            <td>证书编号</td>
            <td>{{ showInfo.code }}</td>
            <td>证书类别</td>
            <td>{{ showInfo.certtypename }}</td>
          </tr>
          <tr>
            <td>申报专业</td>
            <td >{{ showInfo.certname }}</td>
            <td>专业方向</td>
            <td >{{ showInfo.majorfield }}</td>
          </tr>
          <tr>
            <td>申报级别</td>
            <td>{{ showInfo.certlevel }}</td>
            <td>考试成绩</td>
            <td>{{ showInfo.certscore }}</td>
          </tr>
          <tr>
           
            <td>发证日期</td>
            <td colspan="3">{{ showInfo.certdate }}</td>
            <!-- <td>有效日期</td>
            <td>{{ formatExcelData(showInfo.valieddate) }}</td> -->
          </tr>
          <tr>
            <td>证书颁发机构</td>
            <td colspan="3">{{ showInfo.regauth }}</td>
          </tr>
          <tr>
            <td>发证机构网址</td>
            <td colspan="3">{{ showInfo.regurl }}</td>
          </tr>
        </table>
        <div class="theader">继续教育记录</div>
        <table  class="personInfo" >
          <!-- <tr class="theader">
            <th colspan="4">
              继续教育记录
            </th>
          </tr> -->
          <div v-for="item in  pagenum" :key="item">
            <tr class="title">
              <td>{{ arrSprtQys[item-1]? arrSprtQys[item-1].title:''}}</td>
              <td>{{ arrSprtQys[item]? arrSprtQys[item].title:''}}</td>
              <td>{{ arrSprtQys[item+1]? arrSprtQys[item+1].title:''}}</td>
              <td>{{ arrSprtQys[item+2]? arrSprtQys[item+2].title:''}}</td>
            </tr>
            <tr class="date">
              <td>{{ arrSprtQys[item-1]? arrSprtQys[item-1].date:''}}</td>
              <td>{{ arrSprtQys[item]? arrSprtQys[item].date:''}}</td>
              <td>{{ arrSprtQys[item+1]? arrSprtQys[item+1].date:''}}</td>
              <td>{{ arrSprtQys[item+2]? arrSprtQys[item+2].date:''}}</td>
              
            </tr>
          </div>
          
        </table>
    </div>
    <div class="bacc">版权所有：zhcp.org.cn</div>
  </div>

</template>

<script>
/**
 * 个人证书查询系统模版
 */
import { IP_TEST } from '@/config';
import QRCode from "qrcodejs2";
import { getFindAll } from '../../request/get'
export default {
  name: "ShowGr",
  data() {
    return {
      IP_TEST,
      webConfig:null,
      arrSprtQys:[],
      pagenum:1
    }
  },
  computed: {
  },
  created(){
    this.getFindAll();
    
  },
  props: {
    showInfo: Object
  },
  mounted() {
    if(this.showInfo.nianjian)
    {
      let arrtmpsprts=this.showInfo.nianjian.split("##");
      for(let i = 0; i < arrtmpsprts.length;i++) {
        this.arrSprtQys[i]={
          title:arrtmpsprts[i].split("||")[0],
          date:arrtmpsprts[i].split("||")[1],
        }
      }
      this.pagenum = Math.ceil( this.arrSprtQys.length/4);
      if(this.pagenum===0)this.pagenum=1;
    }
	// this.creatQrCode(this.showInfo.cardid,this.showInfo.name,this.showInfo.bzcode,this.showInfo.certname);
  },
  methods: {
    async getFindAll() {
      let result = await getFindAll();
      result = result.data[0] || null;
      this.webConfig = result;
      this.$store.dispatch("SET_WEBCONFIG", result);
    },
    goHome() {
      this.$router.push("/");
    },
    formatExcelData(value) {
      let dataStr = this.formatExcel(value);
      if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
          value = new Date(dataStr);
          if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
              value.setDate(value.getDate() + 1);
          value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
          -2
          )}月${("00" + value.getDate()).slice(-2)}日`;
          return value;
      } else {
          if (dataStr.indexOf("年") > -1) {
              var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
              ttDate = ttDate.replace(/[^0-9]/gm, "-");
              value = new Date(ttDate);
              value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
              return value;
          } else {
              if (!isNaN(dataStr)) {
                  var data = new Date(1900, 0, dataStr);
                  value = data;
                  value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
                  return value;
              } else {
                  return dataStr;
              }
          }
      }
  },
   formatExcel(value) {
      if (!value) {
          return "";
      } else {
          if (typeof value == "string") {
              return value.trim();
          } else {
              return value.toString().trim();
          }
      }
  },
	creatQrCode(code, name,bzcode,certname) {
		if(!bzcode)bzcode='';
		if(!code)code='';
		if(!name)name='';
		if(!certname)certname='';
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: encodeURI(
          `${this.IP_TEST}/showM?cname=${name}&ccode=${code}&bzcode=${bzcode}&certname=${certname}&selectid=1`
        ), // 需要转换为二维码的内容
        width: 117,
        height: 117,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
  }
};
</script>
<style scoped>
.contentbox{
  background-image: url(/static/img/img/bggg.png);
  background-size: cover;
  height: 1300px;
  padding-bottom: 80px;
}
.contentbox .header{
  width: 100%;
  padding:16px 0 16px;

height: auto;
background: #FFFFFF;
box-shadow: 0px 2px 10px 0px rgba(65,65,65,0.09);
}
.contentbox .headerbox{
  width: 1300px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.headerbox img{
  width:608px;
  /* height:49px; */
}
.headerbox .back{
  float:right;
  width: 258px;
  height: 42px;
border: 1px solid #2F8EEC;
}
.headerbox a{
  display: inline-block;
  width: 129px;
height: 42px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
line-height: 42px;

text-align: center;
}
.headerbox a.light{
background: #2E8EEB;

color: #FFFFFF;
}
.contentbox .show{
  width: 1300px;
  margin: auto;
  margin-top: 24px;
  background: linear-gradient(180deg, #FFFFFF, #C0D3F6);
  border-radius: 18px;
  min-height: 965px;
  padding-bottom: 50px;
}
.contentbox .show .tip{
  position: relative;
  margin: auto;
  margin-top: 47px;
  width: 1073px;
  padding-left: 193px;
height: 61px;
background: #FFEEED;
font-size: 18px;
font-family: PingFang SC;
font-weight: bold;
color: #F24040;
line-height:61px;
background-image: url(/static/img/img/reccet.png);
background-repeat: no-repeat;
background-size: 20px 20px;
background-position: 163px center;
}
.toplogo{
  width: 100%;
  height: 35px;
  margin: auto;
  position: relative;
  padding-top: 52px;
  padding-bottom: 26px;
}
.toplogo h1{
  font-size: 35px;
  font-weight: bold;
  color: #000000;
  line-height: 35px;
  text-align: center;
  letter-spacing: 3px;
}
.toplogo h1::after{
  position: absolute;
  left:632px;
  bottom:-5px;
  content:'';
  width: 37px;
height: 8px;
background: #2E8EEB;
border-radius: 3px;
}
.personInfo{
  width:1264px;
  margin: auto;
  /* margin-top: 47px; */
  font-size: 14px;
  border-collapse:collapse;
  border-spacing:0;
  border-left:1px solid #6B8FDB;
  border-top:1px solid #6B8FDB;
}
.personInfo td{
  border-right:1px solid #6B8FDB;
  border-bottom:1px solid #6B8FDB;
  /* padding:5px 15px; */
  height: 54px;
  line-height: 54px;
  padding-left: 22px;
  font-size: 14px;
font-weight: 500;
}
.personInfo th{
  background: #DDEBFC;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  height: 46px;
  line-height: 24px;
  text-align: left;
  font-size: 24px;
}
.personInfo tr td:nth-child(2n-1){
  width: 530px;
}
.personInfo tr td:nth-child(2n){
  width: 530px;
}
.theader{
  position: relative;
  margin:47px auto 0;
  width: 1266px;
  height: 24px;
  text-align: left;
  font-weight: bold;
  color: #000000;
  font-size: 24px;
  line-height: 24px;
  padding-bottom:22px ;
}

.personInfo .title td:nth-child(2n-1){
  width: 25%;
    height: 80px;
    text-align: center;
    padding: 0;
    line-height: 80px;
    color: red;
}
.personInfo .title td:nth-child(2n){
  width: 25%;
    height: 80px;
    text-align: center;
    padding: 0;
    line-height: 80px;
    color: red;
}

.personInfo .date td:nth-child(2n-1){
    height: 40px;
    text-align: center;
    padding: 0;
    line-height: 40px;
    color: red;
}
.personInfo .date td:nth-child(2n){
    text-align: center;
    padding: 0;
    height: 40px;
    line-height: 40px;
    color: red;
}
.bacc{
  position: relative;
  margin-top:61px;
  text-align: center;
height: 14px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #000000;
line-height: 14px;
}
</style>